(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["metaobject-faq"] && !Shopify.designMode) return;
  try {
    const acc = document.getElementsByClassName("metaobject-accordion");
for (let i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    // Close all panels first
    for (let j = 0; j < acc.length; j++) {
      if (acc[j] !== this) {
        acc[j].classList.remove("metaobject-active");
        acc[j].nextElementSibling.style.maxHeight = null;
      }
    }
    
    // Toggle current one
    this.classList.toggle("metaobject-active");
    const panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
